export const GRAPH_API_FRAGMENT_DEFINITION = Symbol('$$resi.graph_fragment_definition');
export const GRAPH_API_FRAGMENT_REFERENCE = Symbol('$$resi.graph_fragment_reference');
//# sourceMappingURL=symbols.js.map